import { Grid, FormLabel, FormControlLabel, Checkbox } from "@material-ui/core";

import StoreList from "./store-list";
import PerfisList from "./perfis-list";

const brands = JSON.parse(localStorage.getItem("usuarioMarcas")) || [];

export default function ViewAccess({
  selectedBrands,
  setSelectedBrands,
  stores,
  storesLoading,
  selectedStoreIds,
  setSelectedStoreIds,
  selectedPerfilIds,
  setSelectedPerfilIds,
}) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormLabel required>Marcas</FormLabel>
        <Grid container>
          {brands
            .filter((brand) => brand.IdMarca !== 0)
            .map((brand) => (
              <FormControlLabel
                key={brand.IdMarca}
                value={brand.Nome}
                label={brand.Nome}
                control={
                  <Checkbox
                    color="primary"
                    size="small"
                    checked={selectedBrands.includes(brand.IdMarca)}
                    onChange={(e) =>
                      setSelectedBrands(
                        e.target.checked
                          ? [...selectedBrands, brand.IdMarca]
                          : selectedBrands.filter((b) => b !== brand.IdMarca)
                      )
                    }
                  />
                }
              />
            ))}
        </Grid>
      </Grid>
      <Grid item xs={12} md={6}>
        <FormLabel>Lojas</FormLabel>
        <StoreList
          stores={stores}
          loading={storesLoading}
          label="Lojas"
          selectedStoreIds={selectedStoreIds}
          onSelectedChange={setSelectedStoreIds}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <FormLabel>Perfis</FormLabel>
        <PerfisList
          selectedPerfilIds={selectedPerfilIds}
          onSelectedChange={setSelectedPerfilIds}
        />
      </Grid>
    </Grid>
  );
}
